import carousel from './part/carousel'
import accordion from './part/accordion'
import videoSlider from './part/vieoSlider'
import imageSlider from './part/imageSlider'
import heroSlider from './part/heroSlider'
import sliderSwiper from './part/productSlider'
import sliderSwiperMobile from './part/productMegabiteSlider'
import scrollHeader from './part/scrollHeader'
import productLightbox from './part/productLightbox'
import popIngredients from './part/popIngredients'

import tippy, { followCursor } from 'tippy.js'
// import reframe from 'reframe.js'

document.addEventListener('DOMContentLoaded', (event) => {
	scrollHeader()

	accordion()

	let mql = window.matchMedia('(min-width:768px)')
	if (mql.matches) {
		tippy(document.querySelectorAll('.tippy'), {
			content(reference) {
				const id = reference.getAttribute('data-template')
				const template = document.getElementById(id)
				return template.innerHTML
			},
			arrow: false,
			allowHTML: true,
			duration: 0,
			animation: 'scale',
			followCursor: true,
			theme: 'fdry',
			plugins: [followCursor],
		})

		const venolight = document.querySelector('.venobox')
		if (typeof venolight != 'undefined' && venolight != null) {
			productLightbox()
		}
	} else {
		popIngredients()

		const productSlider = document.querySelector(
			'.swiper__image-megabite-mobile'
		)
		if (typeof productSlider != 'undefined' && productSlider != null) {
			sliderSwiperMobile()
		}
	}

	// THIS POTENTIALY IS NOT NEEDED IT WAS USED ON DEFAULT PRODUCT PAGE to power the old carousel
	// maybe leave it and change .swiper check to fire it otherwise will fire on all other page with swiper JS el
	const productSlider = document.querySelector('.swiper')
	if (typeof productSlider != 'undefined' && productSlider != null) {
		sliderSwiper()
	}

	const videoCarousel = document.querySelector('.glideVideo')
	if (typeof videoCarousel != 'undefined' && videoCarousel != null) {
		videoSlider()
	}

	const imageSliderContainer = document.querySelector('.glideImageCarousel')
	if (
		typeof imageSliderContainer != 'undefined' &&
		imageSliderContainer != null
	) {
		imageSlider()
	}

	const heroCarousel = document.querySelector('.glideHero')
	if (typeof heroCarousel != 'undefined' && heroCarousel != null) {
		heroSlider()
	}

	const carouselGlide = document.querySelector('.glide')
	if (typeof carouselGlide != 'undefined' && carouselGlide != null) {
		carousel()
	}
})
